import {  Image,  StyleSheet, Text, View, TouchableOpacity, ScrollView, useWindowDimensions, Linking, Dimensions, ActivityIndicator } from 'react-native';
import React, {useState, useEffect} from 'react';
import Carousel, { Pagination, PaginationLight } from 'react-native-x-carousel';
const { width } = Dimensions.get('window');
import RenderHtml from 'react-native-render-html';

export default function Diagnostic({navigation, route}) {

  const { tokenKey } = route.params;
  const { email } = route.params;
  const { Nume } = route.params;
  const { preNume } = route.params;
  const {  PUN_utilizatorID } = route.params;
  const {  Diagnostic } = route.params;
  const { currentDate } = route.params;
  const { sectiune } = route.params;
  const { noPutActionUtilizator } = route.params;

  const windowHeight = useWindowDimensions().height;
  const [isLoading, setLoading] = useState(false);
  const [isPanic, setPanic] = useState(false);


  const [WTD, setWTD] = useState();
  const DiagWTD = async  (wtd) => {
    try {
      const response = await fetch('https://rupertapi.azurewebsites.net/api/DiagWTD', {
        method:'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+tokenKey
        },
        body: JSON.stringify(
          {
            "wtd": wtd
          }
        )
      }
      )
      const json = await response.json();
      console.log();
      setWTD(json);
      setLoading(true);
      setPanic(false);
    } catch (error) {
      console.error(error);
      setError('Diagnostic not found!');
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }



  const renderItem = data => (
    <View
      key={data.coverImageUri}
      style={styles.cardContainer}
    >
      <View
        style={styles.cardWrapper}
      >
        <Image
          style={styles.card}
          source={{ uri: data.coverImageUri }}
        />
        <View
          style={[
            styles.cornerLabel,
            { backgroundColor: data.cornerLabelColor },
          ]}
        >
          <Text style={styles.cornerLabelText}>
            { data.cornerLabelText }
          </Text>
        </View>
      </View>
    </View>
  );
  let [descriere, setDescriere] = useState('');
  let [criterii, setCriterii] = useState('');
  let [denumire, setDenumire] = useState('');
  let [continuewith, setContinuewith] = useState('');
  const GetAfectiunes = async  () => {
    try {
      const response = await fetch('https://rupertapi.azurewebsites.net/api/afectiune', {
        method:'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+tokenKey
        },
        body: JSON.stringify(
          {
            "sectiune": sectiune
          }
        )
      }
      )
      const json = await response.json();
      console.log();
      setDescriere(json[0].intrebari);
      setDenumire(json[0].denumire);
      setCriterii(json[0].criterii);
      setContinuewith(json[0].nextSection);
      DiagWTD(json[0].conditie);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }

  const Descrierehtml = {
    html: 
  descriere
  };
  const Cesafacihtml = {
    html: 
  criterii
  };

  //Put Diagnostic into Actions 
  const PutActionUtilizator = async  (DID) => {
    try {
      const response = await fetch('https://rupertapi.azurewebsites.net/api/action', {
        method:'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+tokenKey
        },
        body: JSON.stringify(
          {
            "UtilizatorID": PUN_utilizatorID,
            "AfectiuniSectiune": DID, //specific diagnostic denumireID
            "Diagnostic": Diagnostic,
            "DataInregistrarii": currentDate,
            "DenumireID": DID //specific diagnostic denumireID 
          }
        )
      }
      )
      const json = await response.json();
      console.log(json);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  // console.log('sectiune: '+sectiune);
  // // console.log('WTD: '+WTD);
  // console.log('continuewith: '+continuewith);

  useEffect(() => {
    setLoading(true);
    setPanic(true);
    if (!noPutActionUtilizator) {
      PutActionUtilizator(sectiune);
      GetAfectiunes();
    } else {
    GetAfectiunes();
    };

  }, []);

  
  return (
    isLoading ?
    <ActivityIndicator size="large" color="#628914" style={{top: 50, alignSelf: 'center', zIndex: 1, elevation: 1 }} />
    :
    <ScrollView>
        <View style={[{ 
          minHeight: Math.round(windowHeight),
          flex: 1,
          backgroundColor: '#fff',
          alignItems: 'center',
          justifyContent: 'center',
          }]}>
        <Text style={styles.h1}>{denumire}.</Text>
        <View style={styles.panel}>
          <TouchableOpacity
                onPress={ () => {
                  navigation.replace('Contul meu',
                      {
                        email:email,
                        preNume:preNume,
                        Nume:Nume,
                        tokenKey:tokenKey, 
                        PUN_utilizatorID:PUN_utilizatorID, 
                        Diagnostic:Diagnostic,
                      
                  })}}
            >
            <Text style={styles.panelbgr}>
              Pe baza răspunsurilor la ȋntrebări, afecțiunea posibilă este:{' '}<Text style={{fontWeight: "bold"}}>{denumire}</Text>.{'\n'}Pentru un diagnostic precis este necesar să consulți {' '}<Text style={{fontWeight: "bold"}}> psihologul.</Text> <Text style={{color:'blue'}}>Apasă aici sa intri in contul tău</Text>.
            </Text> 
            </TouchableOpacity>
        </View>

        {/* PENTRU PANICA CAROUSEL */}
        {isPanic ?  (
          null
        ) : (
        <View>
          <Text style={styles.h1}>Ce poți face în cazul acestei afecțiuni:</Text>
          <Carousel
              pagination={PaginationLight}
              renderItem={renderItem}
              autoplayInterval={4500}
              data={WTD}
              loop
              autoplay
            /> 
          </View>
        )}

        <View style={styles.html}>  
        <Text style={styles.h2}>Descriere</Text> 
        {/* <Text style={styles.MainText}>{descriere}</Text> */}
        {/* <Text style={styles.MainText}>{criterii}</Text> */}
        <RenderHtml     
          contentWidth={width}
          source={Descrierehtml}
        />
        <RenderHtml
          contentWidth={width}
          source={Cesafacihtml}
        />
        </View>
        <TouchableOpacity 
          style={styles.AgainBtn} 
          onPress={() => {
            if (continuewith === 'D24' || continuewith === 'D25') {
              navigation.replace('Contul meu',
                  {
                        email:email,
                        preNume:preNume,
                        Nume:Nume,
                        tokenKey:tokenKey, 
                        PUN_utilizatorID:PUN_utilizatorID, 
                        Diagnostic:Diagnostic,
                      
                  })
            } else {
            navigation.push('Intrebari',
            {
              PUN_utilizatorID:PUN_utilizatorID,
              PUN_U_Status:2,
              tokenKey:tokenKey,
              continuewith: continuewith
            });
          }
          }}
        >
            <Text style={{ color: "#fff" }}>Continuă cu întrebările</Text>
        </TouchableOpacity>

        <Text style={styles.MainText}>
        Crezi că ai nevoie de o analiză clară și completă și dorești să discuți cu un psihoterapeut? Programează-te pentru o ședință aici:
        </Text>
        
        <TouchableOpacity 
          style={styles.ProgramBtn} 
          onPress={() => {
            Linking.openURL('https://psihomaestru.ro/terapie-individuala');
          }}
        >
            <Text style={{ color: "#fff" }}>Programează-te pentru o ședință</Text>
        </TouchableOpacity>
        </View>
    </ScrollView>                         
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
    width:"100%",
    height:"100%"
  },
  video: {
    alignSelf: 'center',
    width:200,
    height:290,
    position:"absolute",
    top:290,
  },
  buttons: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  h1: {
    fontSize: 16,
    alignContent: "flex-start",
    alignSelf: 'flex-start',
    left:10,
    right:20,
    fontWeight: 'bold',
    color:"#3E473A",
    padding:10
  },
  h2: {
    fontSize: 14,
    alignContent: "flex-start",
    alignSelf: 'flex-start',
    left:20,
    color:"#628914",
    paddingTop:10,
  },
  panel: {
    flex: 1,
    padding:10,
    paddingTop: 20,
    shadowColor: '#000',
    width:400,
  },
  panelbgr: {
    height: '100%',
    width: '100%',
    borderRadius: 20,
    backgroundColor: '#CCD8A6',
    padding:10
  },
  MainText: {
    fontSize: 16,
    color: "#3E473A",
    flexShrink: 1,
    padding:20,
    textAlign: 'justify'
  },
  hyperlinkStyle: {
    color: 'blue',
  },
  cardContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    width,
  },
  cardWrapper: {
    borderRadius: 8,
    overflow: 'hidden',
  },
  card: {
    width: width * 0.9,
    height: width * 0.8,
  },
  cornerLabel: {
    position: 'absolute',
    top: 0,
    right: 0,
    borderBottomLeftRadius: 8,
  },
  cornerLabelText: {
    fontSize: 14,
    color: '#fff',
    fontWeight: '600',
    paddingLeft: 38,
    paddingRight: 25,
    paddingTop: 2,
    paddingBottom: 2,
  },
  AgainBtn: {
    backgroundColor: '#628914',
    alignSelf: 'center',
    width: 300,
    height: 50,
    borderRadius:20,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width:0,
      height:3,
    },
    marginBottom:30,
  },
  ProgramBtn: {
    backgroundColor: '#628914',
    alignSelf: 'center',
    width: 300,
    height: 50,
    borderRadius:20,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width:0,
      height:3,
    },
    // top:40,
    marginBottom:30,
  },
  html: {
    left: 20,
    marginRight: 30
  }
});